import React from 'react';

const Hero = ({ title, subtitle, ...props }) => (
  <div className="section section-header section-header-about">
    <div className="parallax filter filter-color-black">
      <div
        className="image"
        style={{
          backgroundImage: `url(${require('../assets/img/resources/header/h4.jpg')})`,
        }}
      />
      <div className="container-fluid">
        <div className="content">
          <h1>{title}</h1>
          <h3 className="subtitle">{subtitle}</h3>
        </div>
      </div>
    </div>
  </div>
);

export default Hero;
